// AUTO-GENERATED by ExternalStubPlugin — do not edit.
// Re-exports of globalThis.$scramjetController (set by the IIFE bundle).
const __external = /** @type {any} */ (globalThis).$scramjetController;
export const {
	Controller,
	Frame,
	ManagedPlugin,
	VERSION,
	assertRuntimeScramjetVersion,
	config,
} = __external;
